import api from './api';

export const managerService = {
  // Dashboard
  getDashboard: async () => {
    const response = await api.get('/manager/dashboard');
    return response.data;
  },

  // User Details
  getUserDetails: async (userId) => {
    const response = await api.get(`/manager/users/${userId}`);
    return response.data;
  },

  // KYC Verification
  verifyKYC: async (userId, status, notes) => {
    const response = await api.put(`/manager/kyc/verify/${userId}`, { status, notes });
    return response.data;
  },

  // Support Tickets
  getTickets: async (params) => {
    const response = await api.get('/manager/tickets', { params });
    return response.data;
  },

  updateTicket: async (ticketId, ticketData) => {
    const response = await api.put(`/manager/tickets/${ticketId}`, ticketData);
    return response.data;
  },

  // Transactions
  viewTransactions: async (params) => {
    const response = await api.get('/manager/transactions', { params });
    return response.data;
  },

  // Withdrawals
  processWithdrawal: async (withdrawalId, action, transactionHash, notes) => {
    const response = await api.put(`/manager/withdrawals/${withdrawalId}/process`, {
      action,
      transaction_hash: transactionHash,
      notes
    });
    return response.data;
  }
};
